import React from "react";
import Home from "./page/Home";

const App: React.FC = () => {
  return <Home />;
};

export default App;